/**
 * The receipt of a publish (redesign #121, §44.7): an ok note (§10.6) at the
 * head of the content, under the publish bar — not lost at the foot of the
 * page — with the product's sentence and its setting keys in mono 12 on white.
 * It enters o 0→1, y 4→0 on r .55 (§35's reveal) and stays until the next
 * change. `role="status"`. No link to the history: the code gives none.
 */
import type React from 'react';
import { color, font } from '../theme/tokens';
import { useMotionMount } from '../lib/presence';
import { Note } from './list';

export function PublishReceipt({ text, codes = [] }: { text: string; codes?: readonly string[] }): React.JSX.Element {
  const reveal = useMotionMount<HTMLDivElement>({ o: 0, y: 4 }, { d: 1, r: 0.55 });
  const pattern = codes.length ? new RegExp(`(${codes.map((code) => code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`) : null;
  const parts = pattern ? text.split(pattern) : [text];
  return (
    <div ref={reveal} role="status">
      <Note tone="teal">
        {parts.map((part, index) =>
          codes.includes(part) ? (
            <code
              key={index}
              style={{ fontFamily: font.mono, fontSize: 12, padding: '1px 5px', borderRadius: 4, background: '#FFFFFF', color: color.ink }}
            >
              {part}
            </code>
          ) : (
            part
          )
        )}
      </Note>
    </div>
  );
}
